// TODO: use this component to render fruit table
import Field, { DataSource } from "./Field";


/**
 * "Empty" for the offline-fallback purpose below — null, undefined or the
 * empty string. Zero counts as a real value (a manually-set pressure of 0
 * is meaningful and should not be papered over with the common-field
 * fallback).
 */
function isEmpty(value: unknown): boolean {
    return value === null || value === undefined || value === "";
}

class FruitField extends Field {
    field_type = "fruit_field";

    // the nested serializer called fruit is removed
    // backend_table = "fruit";
    backend_table = "fruit";

    // * set the value from one of the the objects
    set_value(datasource: DataSource): this {
        const fruit = datasource.fruit as Record<string, unknown> | null;
        if (!fruit) {
            this.value = this.value_filter("-", datasource);
            this.set_color_code(null);
            return this;
        }

        // Primary read via the configured fieldname_getter. When the config
        // points it at a backend-derived field (e.g. pressure_or_prediction,
        // which is a Python @property on Fruit, or a flag_* set by the
        // business-rules endpoint), the value will be absent on the
        // optimistic / offline avocado — the server never ran the
        // derivation. Tenant configs declare the underlying real column via
        // `fieldname_getter_common_field` (see Bakker's ripening
        // summary_fruit_fields_v2, where Pressure pairs
        // pressure_or_prediction → pressure). Fall back to it when the
        // primary is empty so the offline summary shows what the user
        // just typed instead of "-".
        let raw = fruit[this.fieldname_getter];
        const commonField = this.field_config?.fieldname_getter_common_field;
        if (isEmpty(raw) && typeof commonField === "string" && commonField && commonField !== this.fieldname_getter) {
            raw = fruit[commonField];
        }

        this.value = this.value_filter(raw, datasource);
        this.set_color_code(fruit);
        return this;
    }

}

export default FruitField;
